import { render, staticRenderFns } from "./StationDepartureItem.vue?vue&type=template&id=1f8db63c&scoped=true"
import script from "./StationDepartureItem.vue?vue&type=script&lang=js"
export * from "./StationDepartureItem.vue?vue&type=script&lang=js"
import style0 from "./StationDepartureItem.vue?vue&type=style&index=0&id=1f8db63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8db63c",
  null
  
)

export default component.exports